// Cricket Data API Service

const CRICKET_API_BASE = "https://api.cricapi.com/v1";
const API_KEY = "YOUR_API_KEY"; 

// GENERIC GET HANDLER (CRICAPI)
const fetchAPI = async (endpoint) => {
  try {
    const response = await fetch(`${CRICKET_API_BASE}${endpoint}`);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Cricket API Error:", error);
    throw error;
  }
};

// CRICKET API SERVICE OBJECT
export const cricketAPI = {

  // Live Score
  getLiveScore: async (matchId) =>
    fetchAPI(`/cric_score?id=${matchId}&apikey=${API_KEY}`),

  // Match Info
  getMatchInfo: async (matchId) =>
    fetchAPI(`/match_info?id=${matchId}&apikey=${API_KEY}`),

  // Matches List
  getMatchesList: async (offset = "0") =>
    fetchAPI(`/matches_list?offset=${offset}&apikey=${API_KEY}`),

  // ================= SERIES =================

  getSeriesList: async (offset = "0") =>
    fetchAPI(`/series_list?offset=${offset}&apikey=${API_KEY}`),

  searchSeries: async (search) =>
    fetchAPI(`/series_search?search=${search}&apikey=${API_KEY}`),

  getSeriesInfo: async (seriesId) =>
    fetchAPI(`/series_info?id=${seriesId}&apikey=${API_KEY}`),

  getSeriesSquads: async (seriesId) =>
    fetchAPI(`/series_squads?id=${seriesId}&apikey=${API_KEY}`),

  getSeriesPointTable: async (seriesId) =>
    fetchAPI(`/series_point_table?id=${seriesId}&apikey=${API_KEY}`),

  // ================= PLAYERS =================

  getPlayersList: async (offset = "0") =>
    fetchAPI(`/players_list?offset=${offset}&apikey=${API_KEY}`),

  searchPlayers: async (search) =>
    fetchAPI(`/players_search?search=${search}&apikey=${API_KEY}`),

  getPlayerInfo: async (playerId) =>
    fetchAPI(`/player_info?id=${playerId}&apikey=${API_KEY}`),

  // ================= FANTASY =================

  getFantasyScorecard: async (matchId) =>
    fetchAPI(`/fantasy_scorecard?id=${matchId}&apikey=${API_KEY}`),

  getFantasyMatchPoints: async (matchId) =>
    fetchAPI(`/fantasy_match_points?id=${matchId}&apikey=${API_KEY}`),

  getFantasyBallByBall: async (matchId) =>
    fetchAPI(`/fantasy_ball_by_ball?id=${matchId}&apikey=${API_KEY}`),

  // ================= MISC =================

  getCountryList: async () =>
    fetchAPI(`/country_list?apikey=${API_KEY}`),
};

// MAP RAW MATCH DATA TO APP FORMAT (FIXED)
export const mapMatchToAppFormat = (apiMatch) => {
  let teamInfo = [];

  // Safely parse TeamInfo JSON string
  try {
    teamInfo = JSON.parse(apiMatch.TeamInfo || "[]");
  } catch (e) {
    console.error("Error parsing TeamInfo:", e);
  }

  return {
    id: apiMatch.Id,
    matchId: apiMatch.MatchId,
    matchName: apiMatch.MatchName,
    matchType: apiMatch.MatchType,
    date: apiMatch.MatchDate,
    status: apiMatch.Status,
    inPlay: apiMatch.InPlay,
    toss: apiMatch.Toss || "",
    result: apiMatch.Result || "",

    // ================= TEAM 1 =================
    away: {
      code: teamInfo?.[0]?.teamSName || "TBD",
      name: teamInfo?.[0]?.teamName || "Team 1",
    },

    // ================= TEAM 2 =================
    home: {
      code: teamInfo?.[1]?.teamSName || "TBD",
      name: teamInfo?.[1]?.teamName || "Team 2",
    },

    // Generate Image URL using imageId
    teamAwayFlagUrl: !teamInfo?.[0]?.imageId
      ? `https://testapi.shriexchange.com/teams/${teamInfo[0].imageId}.png`
      : "https://cdn-icons-png.flaticon.com/512/4216/4216680.png",

    teamHomeFlagUrl: !teamInfo?.[1]?.imageId
      ? `https://testapi.shriexchange.com/teams/${teamInfo[1].imageId}.png`
      : "https://cdn-icons-png.flaticon.com/512/4216/4216680.png",

    venue: apiMatch.Venue || "",
    score: apiMatch.Score || [],
    fantasyEnabled: apiMatch.FantasyEnabled || false,
    hasSquad: apiMatch.HasSquad || false,

    apiMatch, // keep original reference
  };
};

// FILTER MATCHES BY STATUS (FIXED FOR NUMERIC STATUS)
export const filterMatchesByStatus = (matches, status) => {
  return matches.filter((match) => {
    const apiMatch = match.apiMatch || match;

    const inPlay = apiMatch.InPlay === true;
    const matchStatus = String(apiMatch.Status || "").toLowerCase();

    if (status === "live") {
      return inPlay || matchStatus === "2";
    }

    if (status === "upcoming") {
      return !inPlay && matchStatus === "1";
    }

    if (status === "completed") {
      return !inPlay && matchStatus === "3";
    }

    return false;
  });
};

export default cricketAPI;
